import { createContext, useContext } from 'react';

import { EMPTY_FUNCTION, POPOVER_ID } from '../../../constants';
import { PopoverContextProps } from '../types';

export const PopoverContext = createContext<PopoverContextProps>({
  gripRef: null,
  is_open: false,
  identifier: POPOVER_ID,
  onClose: EMPTY_FUNCTION,
});

export const usePopoverContext = () => useContext(PopoverContext) as PopoverContextProps;
